export const FilterMap = {
  search: "storeName",
  district: "district"
}

export const FILTER_KEY = {
  SEARCH: "search",
  DISTRICT: "district",
  AREA: "area",
  SERVICES: "services"
}
